module.exports = __webpack_public_path__ + "static/media/ShoppingX.e9c2eb5d.png";